import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import { ValidMe, phoneTypesEnum } from '../../../../businessLogic/validation.js';
import { updateWaitingAreaSmsNotificationForm } from '../../../../actions/waitingArea.js';
import { clone } from '../../../../reducers/helper.js';
import HtmlToReact from 'html-to-react';
import xss from 'xss';
let htmlToReactParser = new HtmlToReact.Parser(React);

@connect(mapStateToProps)
export default class CenterPanelUpdateSmsNotification extends React.Component {
  constructor(props) {
    super(props);
  }

  waitingAreaSmsFormUpdated = (property, value) => {
    let val = value;
    var clonedWaitingAreaSmsNotificationForm = clone(this.props.waitingAreaSmsNotificationForm);
    property.map((option, i) => {
      clonedWaitingAreaSmsNotificationForm[option] = value[i];
    }, this);
    clonedWaitingAreaSmsNotificationForm.myProviderStatus = this.props.myProviderStatus;
    return clonedWaitingAreaSmsNotificationForm;
  };

  waitingAreaSecondsNotificationChange = (e) => {
    let value = '';
    if (typeof e != 'number') value = parseInt(e.target.value, 10);
    else value = e;
    if (!isNaN(value)) {
      if (value >= 0) {
        if (value > 99) {
          value = 99;
        }
        this.props.dispatch(
          updateWaitingAreaSmsNotificationForm(
            this.waitingAreaSmsFormUpdated(['secondsIntervalToSmsSendNotification'], [value])
          )
        );
      }
    }
    if (e.target && e.target.value == '') {
      value = 0;
      this.props.dispatch(
        updateWaitingAreaSmsNotificationForm(
          this.waitingAreaSmsFormUpdated(['secondsIntervalToSmsSendNotification'], [value])
        )
      );
    }
  };

  waitingAreaMobilePhoneNumberChanged = (value) => {
    this.props.dispatch(
      updateWaitingAreaSmsNotificationForm(this.waitingAreaSmsFormUpdated(['mobilePhoneNumber'], [value]))
    );
  };

  render() {
    let validationPhoneNumber = 'phoneNumber' + '@emptyok';
    return (
      <div className="ui form">
        <label htmlFor={APP.LANGUAGE.UpdateCreateSmsNotification.id} className="bold title-sms">
          {APP.LANGUAGE.UpdateCreateSmsNotification.Title}
        </label>
        <ValidMe validmefor={validationPhoneNumber} group="updateWaitingAreaSmsNotificationForm">
          <Txt
            fieldClasses="notification-mobile-number"
            tabIndex="1"
            focusme="true"
            id={APP.LANGUAGE.UpdateCreateSmsNotification.id}
            value={this.props.waitingAreaSmsNotificationForm.mobilePhoneNumber}
            notRenderPlaceholderAsTitle={true}
            onChange={this.waitingAreaMobilePhoneNumberChanged}
          />
        </ValidMe>
        <p className="warning-notification mrbxl mrts">
          <i className="ui icon warning circle" />
          <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.UpdateCreateSmsNotification.WarningMessage))}</span>
        </p>

        <div className="mrtsss mxwdtmlpx span-like mrbnull field">
          <Txt
            onClick={this.props.selectText}
            upArrowAction={() => {
              this.waitingAreaSecondsNotificationChange(
                this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification + 1
              );
            }}
            downArrowAction={() => {
              this.waitingAreaSecondsNotificationChange(
                this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification - 1
              );
            }}
            arrowSlider
            value={this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification}
            placeholder={APP.LANGUAGE.UpdateCreateSmsNotification.PhonePlaceholder}
            noTitle
            onChange={this.waitingAreaSecondsNotificationChange}
          />
        </div>
        <div className="right-hand-seconds-notification">
          <label>{APP.LANGUAGE.UpdateCreateSmsNotification.PlaceholderUpdateSmsNotificationSeconds}</label>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    waitingAreaSmsNotificationForm: state.waitingAreaReducer.waitingAreaSmsNotificationForm,
  };
}
